import type { TPopupState } from '../utils/types';
import { atom } from 'recoil';

export const popupState = atom<TPopupState>({
  key: 'popupState',
  default: { popup: null },
});
